import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { css } from "@emotion/css";
import { theme } from "../theme";
export const SegmentedControl = ({ segments, onChange, selectedIndex, }) => {
    const renderSegments = () => segments.map((segment, idx) => (_jsx(Fragment, { children: _jsx("li", { className: selectedIndex === idx ? "selected" : undefined, onClick: () => onChange(idx), children: segment }) }, idx)));
    return (_jsx("div", { className: cls.segmentedControl, children: _jsx("ul", { children: renderSegments() }) }));
};
const cls = {
    segmentedControl: css `
    border: 1px solid ${theme.color.borderLightGray};
    border-radius: 8px;
    padding: 5px;
    display: inline-block;

    & > ul {
      display: table-row;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
    }

    & > ul > li {
      color: ${theme.color.primary};
      background: #fff !important;
      border: 1px solid ${theme.color.borderLightGray};
      border-radius: 8px;
      font-size: 15px;
      font-weight: 500;
      height: 40px;
      min-width: 138px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 15px;
    }

    & > ul > li.selected {
      background: ${theme.color.primary} !important;
      color: #fff !important;
      border: 1px solid ${theme.color.primary};
    }

    & > ul > li:first-of-type {
      margin-left: 0 !important;
    }
  `,
};
